import { createAction } from 'redux-actions';
import { getDataProvider } from '../../data-providers';

export const closeWebview = createAction('CLOSE_WEBVIEW', () => {
  return getDataProvider().closeWebview();
});

export const openPrivacyPolicy = createAction('OPEN_PRIVACY_POLICY', () => {
  return getDataProvider().openPrivacyPolicy();
});

export const openTermsOfUse = createAction('OPEN_TERMS_OF_USE', () => {
  return getDataProvider().openTermsOfUse();
});

export const openForum = createAction('OPEN_FORUM', () => {
  return getDataProvider().openForum();
});

export const redirectToLogin = createAction('REDIRECT_TO_LOGIN', () => {
  return getDataProvider().redirectToLogin();
});

export const openCoppaHelp = createAction('OPEN_COPPA_HELP', () => {
  return getDataProvider().openCoppaHelp();
});
